// apps/web/src/lib/painel/home/numero-animado.ts — Fase 17.8, Plano 03 (D-14, D-19; UI-SPEC U-23).
// Funções puras do número ao vivo: curva da contagem inicial e colunas do rolo de dígitos.

// cubic-bezier(.2,.7,.3,1) = var(--ease-out).
const X1 = 0.2;
const Y1 = 0.7;
const X2 = 0.3;
const Y2 = 1;

function bezier(t: number, a: number, b: number): number {
  const u = 1 - t;
  return 3 * u * u * t * a + 3 * u * t * t * b + t * t * t;
}

/** Fração da curva (0..1) para o progresso de tempo `x` (0..1), por bissecção. */
function easeOut(x: number): number {
  let baixo = 0;
  let alto = 1;
  for (let i = 0; i < 32; i += 1) {
    const meio = (baixo + alto) / 2;
    if (bezier(meio, X1, X2) < x) baixo = meio;
    else alto = meio;
  }
  return bezier((baixo + alto) / 2, Y1, Y2);
}

/** Valor mostrado na contagem inicial: 0 no começo, `final` no fim, ease-out entre eles. */
export function valorDaContagem(final: number, progresso: number): number {
  if (progresso <= 0) return 0;
  if (progresso >= 1) return final;
  return final * easeOut(progresso);
}

export interface ColunaDoRolo {
  readonly de: string;
  readonly para: string;
  readonly muda: boolean;
}

/** Colunas alinhadas à direita; só as que mudam (`muda`) rolam. Coluna ausente num dos lados vem como ''. */
export function colunasDoRolo(anterior: string, atual: string): readonly ColunaDoRolo[] {
  const tamanho = Math.max(anterior.length, atual.length);
  const a = anterior.padStart(tamanho, ' ');
  const b = atual.padStart(tamanho, ' ');
  const colunas: ColunaDoRolo[] = [];
  for (let i = 0; i < tamanho; i += 1) {
    const de = (a[i] ?? ' ').trim();
    const para = (b[i] ?? ' ').trim();
    colunas.push({ de, para, muda: de !== para });
  }
  return colunas;
}
